import {
	EMI_ITEM_LEVEL_BREAKUP_REQUEST,
	EMI_ITEM_LEVEL_BREAKUP_SUCCESS,
	EMI_ITEM_LEVEL_BREAKUP_ERROR,
	EMI_ITEM_LEVEL_BREAKUP_RESET
} from 'actions/PaymentActions/PaymentActions';
import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper.ts';

export const INITIAL_STATE = {
	asyncStatus: INIT,
	breakup: [],
	error: null
};

export default function emiItemLevelBreakup(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case EMI_ITEM_LEVEL_BREAKUP_RESET:
			return INITIAL_STATE;
		case EMI_ITEM_LEVEL_BREAKUP_REQUEST:
			return Object.assign({}, state, { asyncStatus: LOADING, breakup: [], error: null });
		case EMI_ITEM_LEVEL_BREAKUP_SUCCESS:
			return Object.assign({}, state, {
				breakup: action.breakup,
				asyncStatus: SUCCESS,
				error: null
			});
		case EMI_ITEM_LEVEL_BREAKUP_ERROR:
			return Object.assign({}, state, {
				asyncStatus: ERROR,
				error: action.error
			});
		default:
			return state;
	}
}
